import {view} from '@sail/ui';

import {NetworkSelectScreen} from 'src/fund/components/networkSelect/NetworkSelectScreen';
import {TokenSelectScreen} from 'src/fund/components/tokenSelect/TokenSelectScreen';
import {useSelector} from 'src/fund/state/store';
import {absurd} from 'src/utils/absurd';
import {MEDIA_QUERIES} from 'src/v2/util/mediaQueries';

export const ScreenManager = () => {
  const screen = useSelector((state) => state.screen);
  let content: React.ReactElement;

  switch (screen) {
    case 'token_select':
      content = <TokenSelectScreen />;
      break;
    case 'network_select':
      content = <NetworkSelectScreen />;
      break;
    default:
      return absurd(screen);
  }

  return (
    <view.div
      css={{
        stack: 'y',
        alignX: 'center',
        paddingTop: 'space.500',
        [MEDIA_QUERIES.mediumWidth]: {
          paddingTop: 'space.0',
        },
      }}
      data-testid="funding-screen-manager"
    >
      {content}
    </view.div>
  );
};
